var $ = require('jquery');

var self = {};

self.initialise = function($youtubePlayer) {
  $youtubePlayer.click(function() {
    $(this).addClass('youtube-playing');
    setupVideo($(this)[0]);
  });

  function setupVideo(video) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      '//www.youtube.com/embed/' +
        video.getAttribute('data-id') +
        '?modestbranding=1&autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&rel=' +
        video.getAttribute('data-related') +
        '&controls=' +
        video.getAttribute('data-control') +
        '&showinfo=' +
        video.getAttribute('data-info')
    );
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('id', 'youtube-iframe');
    iframe.setAttribute('style', 'width: 100%; height: 100%; position: absolute; top: 0; left: 0;');
    if (video.getAttribute('data-fullscreen') == 1) {
      iframe.setAttribute('allowfullscreen', '');
    }
    while (video.firstChild) {
      video.removeChild(video.firstChild);
    }
    video.appendChild(iframe);
  }

  function buttonPlayVideo() {
    $('.youtube-player')
      .find('a')
      .click(function(e) {
        e.preventDefault();
        $(this)
          .parent()
          .click();
      });
  }

  buttonPlayVideo();
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/youtubeVideo.js